import React, { Component } from 'react';
import { connect } from 'react-redux';
import ProductImage from './ProductImage';
import * as api from '../../moltin';

import { UPDATE_QUANTITY } from '../../ducks/product';
import {
  FETCH_CART_START,
  FETCH_CART_END,
  CART_UPDATED
} from '../../ducks/cart';

const mapStateToProps = state => {
  return state;
};

class SingleProduct extends Component {
  render() {
    var products = this.props.products.products;

    var ID = this.props.router.location.pathname.slice(9, 100);

    var productArray = this.props.products.products.data.filter(function(
      product
    ) {
      return product.id === ID;
    });

    var product = productArray[0];

    var updateQuantity = quantity => {
      this.props.dispatch(dispatch => {
        dispatch({ type: UPDATE_QUANTITY, payload: quantity });
      });
    };

    var addToCart = id => {
      this.props.dispatch(dispatch => {
        api
          .AddCart(id, this.props.product.quantity)

          .then(cart => {
            console.log(cart);
            dispatch({ type: CART_UPDATED, gotNew: false });
          })

          .then(() => {
            dispatch({ type: FETCH_CART_START, gotNew: false });

            api
              .GetCartItems()

              .then(cart => {
                dispatch({ type: FETCH_CART_END, payload: cart, gotNew: true });
              });
          })
          .catch(e => {
            console.log(e);
          });
      });
    };

    var background = product.background_colour;

    function isThereACurrencyPrice() {
      try {
        return (
          <p className="price">
            <span className="hide-content">Unit price </span>
            {'$' + product.meta.display_price.with_tax.amount / 100}
          </p>
        );
      } catch (e) {
        return <div className="price">Price not available</div>;
      }
    }

    function isThereStock(my_product) {
      if (product.meta.stock.availability === "in-stock") {
        return (
          <form className="product" noValidate>
              <div className="quantity-input">
                <p className="hide-content">Product quantity.</p>
                <p className="hide-content">
                  Change the quantity by using the buttons, or alter the
                  input directly.
                </p>
                <button
                  type="button"
                  className="decrement number-button"
                  onClick={() => {
                    updateQuantity(my_product.props.product.quantity - 1);
                  }}>
                  <span className="hide-content">Decrement quantity</span>
                  <span aria-hidden="true">-</span>
                </button>
                <input
                  className="quantity"
                  name="number"
                  type="number"
                  min="1"
                  max="10"
                  value={my_product.props.product.quantity}
                  size="2"
                  onChange={event => {
                    updateQuantity(event.target.value);
                  }}
                />
                <button
                  type="button"
                  className="increment number-button"
                  onClick={() => {
                    updateQuantity(my_product.props.product.quantity + 1);
                  }}>
                  <span className="hide-content">Increment quantity</span>
                  <span aria-hidden="true">+</span>
                </button>
              </div>
              <button
                type="submit"
                className="submit"
                onClick={e => {
                  addToCart(product.id);
                  console.log(my_product.props.product.quantity);
                  e.preventDefault();
                }}>
                Add to cart
              </button>
          </form>
        );
      }
      else {
        return (
        <div style={{"width":"150px"}}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 138.34 42.6">
        <rect fill="#edadad" width="138.34" height="42.6"/>
        <path fill="#fff" d="M12.9,21.9V13.8h1v8.06c0,3.51,1.69,5.16,4.62,5.16s4.6-1.65,4.6-5.16V13.8h1v8.1c0,4-2.15,6.07-5.65,6.07S12.9,25.92,12.9,21.9Z"/>
        <path fill="#fff" d="M38,21.74v6.13H37V21.82c0-2.38-1.27-3.62-3.4-3.62a3.75,3.75,0,0,0-4,4.08v5.59h-1V17.37h1v2.28a4.33,4.33,0,0,1,4.16-2.36C36.32,17.29,38,18.8,38,21.74Z"/>
        <path fill="#fff" d="M49.75,21.21v6.66h-1V26A4,4,0,0,1,45,28c-2.36,0-3.78-1.21-3.78-3,0-1.59,1-2.93,3.92-2.93h3.6v-.85c0-2-1.07-3-3.12-3A5.47,5.47,0,0,0,42,19.5l-.5-.72a6.41,6.41,0,0,1,4.2-1.49C48.3,17.29,49.75,18.62,49.75,21.21Zm-1,3.56v-2H45.17c-2.17,0-2.94.91-2.94,2.11,0,1.37,1.07,2.21,2.92,2.21A3.6,3.6,0,0,0,48.75,24.77Z"/>
        <path fill="#fff" d="M62.11,17.37l-4.74,10.5h-1l-4.72-10.5h1.07l4.18,9.39,4.22-9.39Z"/>
        <path fill="#fff" d="M71.56,21.21v6.66h-1V26A4,4,0,0,1,66.82,28C64.47,28,63,26.74,63,25,63,23.36,64,22,67,22h3.6v-.85c0-2-1.07-3-3.12-3a5.47,5.47,0,0,0-3.62,1.32l-.5-.72a6.43,6.43,0,0,1,4.2-1.49C70.11,17.29,71.56,18.62,71.56,21.21Zm-1,3.56v-2H67c-2.17,0-2.94.91-2.94,2.11,0,1.37,1.07,2.21,2.92,2.21A3.6,3.6,0,0,0,70.56,24.77Z"/>
        <path fill="#fff" d="M75.38,14a.83.83,0,0,1,.83-.83.82.82,0,1,1-.83.83Zm.32,3.35h1v10.5h-1Z"/>
        <path fill="#fff" d="M81,13h1V27.87H81Z"/>
        <path fill="#fff" d="M93.77,21.21v6.66h-1V26A4,4,0,0,1,89,28c-2.35,0-3.78-1.21-3.78-3,0-1.59,1-2.93,3.92-2.93h3.6v-.85c0-2-1.07-3-3.12-3A5.45,5.45,0,0,0,86,19.5l-.51-.72a6.45,6.45,0,0,1,4.2-1.49C92.33,17.29,93.77,18.62,93.77,21.21Zm-1,3.56v-2H89.19c-2.17,0-2.93.91-2.93,2.11,0,1.37,1.06,2.21,2.91,2.21A3.59,3.59,0,0,0,92.77,24.77Z"/>
        <path fill="#fff" d="M108.37,22.62A5.09,5.09,0,0,1,103.18,28a4.7,4.7,0,0,1-4.3-2.56v2.48h-1V13h1v6.82a4.7,4.7,0,0,1,4.26-2.48A5.08,5.08,0,0,1,108.37,22.62Zm-1,0a4.23,4.23,0,1,0-8.46,0,4.23,4.23,0,1,0,8.46,0Z"/>
        <path fill="#fff" d="M111.48,13h1V27.87h-1Z"/>
        <path fill="#fff" d="M125.6,22.86h-9a4.5,4.5,0,0,0,7.8,2.72l.58.66A5,5,0,0,1,121,28a5.15,5.15,0,0,1-5.4-5.33,5,5,0,1,1,10,0C125.62,22.66,125.6,22.76,125.6,22.86Zm-9-.78h8a4,4,0,0,0-8,0Z"/>
        </svg>
        </div>
        );
      }
    }

    return (
      <main role="main" id="container" className="main-container push">
        <section className="product">
          <div className="content">
            <div className="product-listing">
              <div className="product-image">
                <ProductImage
                  product={product}
                  products={products}
                  background={background}
                />
              </div>
              <div className="product-description">
                <h2>{product.name}</h2>
                <p className="manufacturer">
                  <span className="hide-content">Manufactured </span>By{' '}
                  <span className="word-mark">
                    Bad Wearable Tech
                  </span>
                </p>
                {isThereACurrencyPrice()}
                <div className="description">
                  <p className="hide-content">Product details:</p>
                  <p>{product.description}</p>
                </div>
                {isThereStock(this)}
              </div>
            </div>

          </div>
        </section>
      </main>
    );
  }
}

export default connect(mapStateToProps)(SingleProduct);



// WEBPACK FOOTER //
// ./src/components/Products/SingleProduct.js